import axios from "axios";
export default {
  name: "cartSection",
  data() {
    return {
      checked1: "checked",
      checked2: "",
      checked3: "",
      checked4: "",
      checked5: "",
      elementTab: [],
      nbRequest: 0,
      tabNbElement: [],
      ArticleCarts: [],
      steps: 1,
      userStat: 0,
      quantite: 0,
      totalePrice: [],
      // totaleCommande: 0,
      etaps: true,
      model: {
        payment: 0,
        owner: {
          ownerId: localStorage.getItem("Giftstore-U"),
          email: "",
          firstName: "",
          lastName: "",
          phoneNumber: "",
        },
        date: "",
        address: "",
        ville: "",
        city: "",
        postalCode: "",
        typeCadeau: 1,
        carteType: 1,

        product: [],
        // userId: window.localStorage.getItem("Giftstore-U"),
      },
      quantity: [],
    };
  },
  async created() {
    // console.log("getters", this.$store.getters);
    // console.log("userInfoBasket", this.$store.getters.getUserInfo);

    // this.model.owner.firstName = this.$store.getters.getUserInfo.firstName;
    // this.model.owner.lastName = this.$store.getters.getUserInfo.lastName;
    // this.model.owner.email = this.$store.getters.getUserInfo.email;
    // if (this.$store.getters.getUserInfo.dateOfBirth) {
    //   var dateUser = new Date(this.$store.getters.getUserInfo.dateOfBirth);
    //   var day = dateUser.getDate();
    //   var month = dateUser.getMonth();
    //   var years = dateUser.getFullYear();
    //   this.model.date =
    //     years + "-" + this.filterDate(month) + "-" + this.filterDate(day);
    // }
    // if (this.$store.getters.getUserInfo.address) {
    //   if (this.$store.getters.getUserInfo.address.exactAddress) {
    //     this.model.exactAddress = this.$store.getters.getUserInfo.address.exactAddress;
    //   }
    //   if (this.$store.getters.getUserInfo.address.ville) {
    //     this.model.ville = this.$store.getters.getUserInfo.address.ville;
    //   }
    //   if (this.$store.getters.getUserInfo.address.city) {
    //     this.model.city = this.$store.getters.getUserInfo.address.city;
    //   }
    //   if (this.$store.getters.getUserInfo.address.postalCode) {
    //     this.model.postalCode = this.$store.getters.getUserInfo.address.postalCode;
    //   }
    //   //if(this.$store.getters.getUserInfo.address.exactAddress){
    //   // this.model.owner.phoneNumber = this.$store.getters.getUserInfo.phoneNumber;
    //   //}
    // }
    await this.$loadScript("./js1/jquery.steps.js");
    await this.$loadScript("./js1/jquery-ui.min.js");
    await this.$loadScript("./js1/main.js");
    this.getElements();
  },
  methods: {
    erreurMessage() {
      this.$toast.open({
        message: "Vous devez être connecter",
        type: "info",
        // position: "top-right",
        // all of other options may go here
      });
    },
    verifyBtn() {
      if (localStorage.getItem("Giftstore-U")) {
        return true;
      } else {
        return false;
      }
    },
    // addCommande() {
    //   var obj = {
    //     quantity: this.quantity,
    //     productId: this.$store.getters.getbasket,
    //     userId: window.localStorage.getItem("Giftstore-U"),
    //   };
    //   console.log(obj);
    // },
    filterDate(valueToChange) {
      return valueToChange.length === 2 ? valueToChange : `0${valueToChange}`;
    },
    onChangeType: function(nb) {
      // this.model.typeCadeau=nb;
      this.$toast.open({
        message: "Cette option sera bientôt disponible",
        type: "info",
      });
    },
    onChangeCarte: function(nb) {
      // this.model.carteType=nb;
      this.$toast.open({
        message: "Cette option sera bientôt disponible",
        type: "info",
      });
    },
    getElements() {
      this.ArticleCarts = [];
      var nb = window.localStorage.getItem("ProductNumber");
      for (var i = 1; i <= nb; i++) {
        var idElement = JSON.parse(window.localStorage.getItem("product" + i));
        // console.log("store",this.$store.getters.getbasket[i-1])
        // this.quantite=this.$store.getters.getbasket[i-1].quantite
        // this.quantite=idElement.quantite
        axios
          .get(
            "https://giftstore-blog.herokuapp.com/api/product/get/" +
              idElement.productId
          )
          .then((response) => {
            response.data.fetchedArticle.quantites = idElement.quantite;
            this.ArticleCarts.push(response.data.fetchedArticle);
            // this.totalePrice=this.numberWithSpaces(this.quantite*response.data.fetchedArticle.productPrice)
            // for (let j = 1; j <= nb; j++) {
            //   if (
            //     window.localStorage.getItem("product" + j) ==
            //     response.data.fetchedArticle._id
            //   ) {
            //     this.ArticleCarts.push(
            //       Object.assign(
            //         { numberElement: "product" + j },
            //         response.data.fetchedArticle
            //       )
            //     );
            //   }
            // }
            // if(this.ArticleCarts){
            //   for (const element of this.ArticleCarts) {
            //     console.log("here1",this.ArticleCarts,element)
            //     if (idElement.id == element._id) {
            //       this.tabNbElement.push(idElement.nb);
            //       console.log("here2",this.tabNbElement,idElement.nb)
            //     }
            //   };
            // }

            console.log("test", this.ArticleCarts);
          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
        // .finally(() => this.totalePriceElement(this.ArticleCarts, nb));
      }
    },
    numberElement(element) {
      // var nb = window.localStorage.getItem("ProductNumber");
      // for (var i = 1; i <= nb; i++) {
      //   var idElement = JSON.parse(window.localStorage.getItem("product" + i));
      //   // for( var element of elements){
      //     console.log("here",elements[i-1]._id,idElement.nb)
      //     if (idElement.id == elements[i-1]._id) {
      //       this.tabNbElement.push(idElement.nb);
      //     }
      //   // }
      // }

      // console.log(this.tabNbElement)

      var nb = window.localStorage.getItem("ProductNumber");
      for (var i = 1; i <= nb; i++) {
        var idElement = JSON.parse(window.localStorage.getItem("product" + i));
        if (idElement.productId == element._id) {
          return idElement.quantite;
        }
      }
    },
    singlePrice(element) {
      var nb = window.localStorage.getItem("ProductNumber");
      for (var i = 1; i <= nb; i++) {
        var idElement = JSON.parse(window.localStorage.getItem("product" + i));
        if (idElement.productId == element._id) {
          return element.productPrice * idElement.quantite;
        }
      }
    },
    totaleCommande() {
      var totalePriceArticle = 0;
      var singlePrice = 0;
      var nb = window.localStorage.getItem("ProductNumber");
      this.ArticleCarts.forEach((element) => {
        console.log("element", element);
        for (var i = 1; i <= nb; i++) {
          var idElement = JSON.parse(
            window.localStorage.getItem("product" + i)
          );
          console.log("idElement", idElement);
          if (idElement.productId == element._id) {
            singlePrice = element.productPrice * idElement.quantite;
            console.log("somme", element.productPrice, idElement.quantite);
            totalePriceArticle = totalePriceArticle + singlePrice;
            console.log("somme", singlePrice, totalePriceArticle);
          }
        }
      });
      return totalePriceArticle + 8;
    },
    // totalePriceElement(element, nb) {
    //   this.totalePrice = [];
    //   this.totaleCommande = 0;
    //   console.log("cart 123", element);
    //   this.nbRequest++;
    //   // this.elementTab.push({
    //   //   productPrice:productPrice,
    //   //   nbElement:nbElement
    //   // })
    //   if (this.nbRequest == nb) {
    //     // console.log(element,"price test")
    //     for (var i = 1; i <= nb; i++) {
    //       var idElement = JSON.parse(
    //         window.localStorage.getItem("product" + i)
    //       );
    //       if (idElement.id == element[i - 1]._id) {
    //         this.totalePrice.push(element[i - 1].productPrice * idElement.nb);
    //         this.totaleCommande =
    //           this.totaleCommande + element[i - 1].productPrice * idElement.nb;
    //       }
    //       console.log("here", this.totalePrice);
    //     }
    //     // console.log(this.totalePrice);
    //     // this.totaleCommande = element.productPrice * idElement.nb;
    //     // return this.numberWithSpaces(this.totalePrice);
    //   }
    //   // var nb = window.localStorage.getItem("ProductNumber");
    //   // for (var i = 1; i <= nb; i++) {
    //   //   var idElement = JSON.parse(window.localStorage.getItem("product" + i));
    //   //   if (idElement.id == element._id) {
    //   //     console.log("cart", idElement, element);
    //   //     this.totalePrice = element.productPrice * idElement.nb;
    //   //   }
    //   // }
    //   // console.log(this.totalePrice);
    //   // this.totaleCommande = element.productPrice * idElement.nb;
    //   // return this.numberWithSpaces(this.totalePrice);
    // },
    userAuth() {
      if (
        window.localStorage.getItem("Giftstore-T") &&
        window.localStorage.getItem("Giftstore-U")
      ) {
        this.userStat = 1;
      } else {
        this.userStat = 0;
      }
    },
    imgCart(element) {
      if (element.typeArticle == "vetements") {
        return (
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[0]
        );
      } else if (element.typeArticle == "chaussure") {
        return (
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[0]
        );
      } else if (element.typeArticle == "tapis") {
        return (
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[0]
        );
      } else if (element.typeArticle == "autre") {
        return (
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[0]
        );
      }
    },
    GetProductNumber() {
      //extracting the theme number from local storage
      if (localStorage.getItem("ProductNumber") === null) {
        return 0;
      } else {
        return localStorage.getItem("ProductNumber");
      }
    },
    deleteElementCart(id) {
      console.log(id);
      var TabThemes = [];
      var nb = this.GetProductNumber();
      window.localStorage.removeItem("ProductNumber");
      var idElement;
      for (var k = 1; k <= nb; k++) {
        idElement = JSON.parse(localStorage.getItem("product" + k));
        if (idElement.productId != id) {
          TabThemes.push(JSON.stringify(idElement));
        }
        window.localStorage.removeItem("product" + k);
      }
      for (var j = 1; j <= TabThemes.length; j++) {
        localStorage.setItem("product" + j, TabThemes[j - 1]);
      }
      localStorage.setItem("ProductNumber", TabThemes.length);
      this.getElements();
      this.$toast.open({
        message: "Produit supprimé au Panier",
        type: "success",
      });
      this.$store.commit("setbasket", TabThemes);
      this.totaleCommande();
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    setCommand() {
      this.model.owner.firstName = this.$store.getters.getUserInfo.firstName;
      this.model.owner.lastName = this.$store.getters.getUserInfo.lastName;
      this.model.owner.email = this.$store.getters.getUserInfo.email;
      if (this.$store.getters.getUserInfo.dateOfBirth) {
        var dateUser = new Date(this.$store.getters.getUserInfo.dateOfBirth);
        var day = dateUser.getDate();
        var month = dateUser.getMonth();
        var years = dateUser.getFullYear();
        this.model.date =
          years + "-" + this.filterDate(month) + "-" + this.filterDate(day);
      }
      if (this.$store.getters.getUserInfo.address) {
        if (this.$store.getters.getUserInfo.address.exactAddress) {
          this.model.address = this.$store.getters.getUserInfo.address.exactAddress;
        }
        if (this.$store.getters.getUserInfo.address.ville) {
          this.model.ville = this.$store.getters.getUserInfo.address.ville;
        }
        if (this.$store.getters.getUserInfo.address.city) {
          this.model.city = this.$store.getters.getUserInfo.address.city;
        }
        if (this.$store.getters.getUserInfo.address.postalCode) {
          this.model.postalCode = this.$store.getters.getUserInfo.address.postalCode;
        }
        if (this.$store.getters.getUserInfo.phoneNumber) {
          this.model.owner.phoneNumber = this.$store.getters.getUserInfo.phoneNumber;
        }
      }
    },
    confirmCommand() {
      //this.selectedCarts
      var articleSend = [];
      var nb = window.localStorage.getItem("ProductNumber");
      for (var i = 1; i <= nb; i++) {
        articleSend.push(
          JSON.parse(window.localStorage.getItem("product" + i))
        );
      }
      this.model.product = articleSend;
      this.model.payment = this.totaleCommande();
      console.log("model", this.model);
      axios
        .post(
          "https://giftstore-blog.herokuapp.com/api/commande/add",
          this.model
        )
        .then((response) => {
          console.log(response.data);
          const productsCount = localStorage.getItem("ProductNumber");
          localStorage.removeItem("ProductNumber");
          for (let index = 1; index <= productsCount; index++) {
            localStorage.removeItem("product" + index);
          }
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
